import { render, staticRenderFns } from "./uploadAtt.vue?vue&type=template&id=4c9ebc88&scoped=true"
import script from "./uploadAtt.vue?vue&type=script&lang=js"
export * from "./uploadAtt.vue?vue&type=script&lang=js"
import style0 from "./uploadAtt.vue?vue&type=style&index=0&id=4c9ebc88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ebc88",
  null
  
)

export default component.exports